import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from './../../../../../Containers/Config/index';
import { CREATE_RULE, CREATE_RULE_SUCCESS, CREATE_RULE_ERROR } from './../../../actionType';
import apiCall from '../../../apiCall';
import { Constant } from '../../../../../Containers/Helpers/constant';
import cogoToast from 'cogo-toast';

function* createRule({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/rules`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`Rule created successfully.`);
      // cogoToast.success(`${response?.data?.message}`)
      yield put({
        type: CREATE_RULE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      // yield put({
      //     type: CREATE_RULE_ERROR,
      //     payload: response?.data?.message,
      // })
    }
  } catch (error) {
    yield put({ type: CREATE_RULE_ERROR, payload: error });
  }
}

export function* watchCreateRuleSaga() {
  yield takeEvery(CREATE_RULE, createRule);
}

function* createRuleSaga() {
  yield all([fork(watchCreateRuleSaga)]);
}

export default createRuleSaga;
